<template>
  <div>
    <v-card
      flat
      class="rounded-lg mt-5 textLight--text"
      style="min-width: 100%; max-width: fit-content; width: fit-content"
    >
      <div
        class="text-center d-flex align-center py-2"
        style="min-height: 65px; width: fit-content"
      >
        <div
          v-if="$route.name === 'EmployeeProfile'"
          class="d-flex flex-row justify-start align-center"
          style="width: 300px"
        >
          <v-img
            :key="`course-card_${registrationData._id}`"
            class="rounded-lg ms-3"
            height="45"
            max-width="45"
            :src="
              registrationData.training && registrationData.training.images
                ? getImage(registrationData.training.images)
                : null
            "
            lazy-src="@/app/core-module/assets/images/logo_placeholder.png"
            cover
          />

          <div class="text-ellipse-2 text-start ms-3 pe-3">
            {{
              registrationData.training && registrationData.training.title
                ? getLocalisedValue(registrationData.training.title)
                : "-"
            }}
          </div>
        </div>

        <div
          v-else
          class="d-flex flex-row justify-start align-center"
          style="width: 300px"
        >
          <v-img
            :key="`course-card_${registrationData._id}`"
            class="rounded-lg ms-3 no-filter"
            height="45"
            max-width="45"
            :src="
              registrationData.employee &&
              registrationData.employee.user &&
              registrationData.employee.user.avatar
                ? getImage(registrationData.employee.user.avatar)
                : null
            "
            lazy-src="@/app/user-module/assets/images/user-placeholder.png"
            cover
          />

          <div class="text-ellipse-2 text-start ms-3 pe-3">
            <span>
              {{
                registrationData.employee &&
                registrationData.employee.user &&
                registrationData.employee.user.firstName
                  ? registrationData.employee.user.firstName
                  : "-"
              }}
              {{
                registrationData.employee &&
                registrationData.employee.user &&
                registrationData.employee.user.lastName
                  ? registrationData.employee.user.lastName
                  : ""
              }}
            </span>
          </div>
        </div>

        <div class="text-ellipse-2 text-start" style="width: 250px">
          {{
            registrationData &&
            registrationData.trainer &&
            registrationData.trainer.user &&
            registrationData.trainer.user.firstName
              ? `${registrationData.trainer.user.firstName || ""} ${
                  registrationData.trainer.user.lastName || ""
                }`
              : " - "
          }}
        </div>

        <div
          v-if="$route.name === 'OrganizationProfile'"
          class="text-ellipse-2 text-start pe-3"
          style="width: 250px"
        >
          {{
            registrationData.training && registrationData.training.title
              ? getLocalisedValue(registrationData.training.title)
              : "-"
          }}
        </div>

        <div class="text-ellipse-2 text-start pe-3" style="width: 150px">
          {{ registrationData.batchNumber || "-" }}
        </div>

        <div class="d-flex justify-center align-center" style="width: 200px">
          <span
            :class="
              registrationData.status === 'REGISTERED'
                ? 'primary--text'
                : registrationData.status === 'COMPLETED'
                ? 'green--text'
                : registrationData.status === 'THIRDPARTY'
                ? 'orange--text'
                : ''
            "
          >
            {{ formatStatus(registrationData.status) }}
          </span>

          <v-menu
            v-if="
              havePermissionUpdateTrainingRegistration &&
              registrationData.status !== 'COMPLETED'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                :loading="statusUpdateLoading"
              >
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                @click="updateRegistrationStatus(item)"
                v-for="(item, i) in registrationStatusArr"
                :key="i"
              >
                <v-list-item-title>{{ formatStatus(item) }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn v-else icon disabled style="visibility: hidden">
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </div>

        <!--@deprecated payment status replaced with employee id-->
        <!--        <div
          class="d-flex justify-center align-center"
          style="width: 200px"
          v-if="registrationData.invoice"
        >
          <span
            :class="
              registrationData.invoice.status === 'PAID'
                ? 'green&#45;&#45;text'
                : registrationData.invoice.status === 'UNPAID'
                ? 'red&#45;&#45;text'
                : 'primary&#45;&#45;text'
            "
          >
            {{
              registrationData.invoice.status
                ? registrationData.invoice.status.charAt(0).toUpperCase() +
                  registrationData.invoice.status.slice(1).toLowerCase()
                : "-"
            }}</span
          >

          <v-menu v-if="havePermissionUpdateTrainingRegistration">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                :loading="invoiceStatusUpdateLoading"
              >
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                @click="updateInvoiceStatus(registrationData.invoice._id, item)"
                v-for="(item, i) in invoiceStatusArr"
                :key="i"
              >
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>-->

        <div class="d-flex justify-center align-center" style="width: 200px">
          {{
            registrationData.employee && registrationData.employee.user
              ? registrationData.employee.user.civilIdOrPassport || "-"
              : "-"
          }}
        </div>

        <div style="width: 200px">
          <span class="">
            {{
              registrationData.startDate
                ? moment(parseInt(registrationData.startDate)).format(
                    "DD MMM YYYY"
                  )
                : "-"
            }}
          </span>

          <v-menu
            v-if="
              havePermissionUpdateTrainingRegistration &&
              registrationData.status !== 'COMPLETED'
            "
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <edit-btn
                v-if="registrationData.startDate"
                @editDate="editStartDate"
                :height="'27'"
                :width="'27'"
                :minusIconSize="'20'"
                :pencilIconSize="'20'"
                :loading="editBtnLoading1"
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker color="primary" v-model="date1" no-title>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
              <v-btn
                v-if="
                  date1 !==
                  moment(parseInt(registrationData.startDate)).format(
                    'YYYY-MM-DD'
                  )
                "
                text
                color="primary"
                @click="updateStartDate"
                >Update</v-btn
              >
            </v-date-picker>
          </v-menu>
        </div>

        <!--@deprecated end date, replaced with certificate expiry-->
        <!--        <div style="width: 200px">
          <span>
            {{
              registrationData.endDate
                ? moment(parseInt(registrationData.endDate)).format(
                    "DD MMM YYYY"
                  )
                : "-"
            }}
          </span>

          <v-menu
            v-if="
              havePermissionUpdateTrainingRegistration &&
              registrationData.status !== 'COMPLETED'
            "
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <edit-btn
                v-if="registrationData.endDate"
                @editDate="editEndDate"
                :height="'27'"
                :width="'27'"
                :minusIconSize="'20'"
                :pencilIconSize="'20'"
                :loading="editBtnLoading2"
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker color="primary" v-model="date2" no-title>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
              <v-btn
                v-if="
                  date2 !==
                  moment(parseInt(registrationData.endDate)).format(
                    'YYYY-MM-DD'
                  )
                "
                text
                color="primary"
                @click="updateEndDate"
                >Update</v-btn
              >
            </v-date-picker>
          </v-menu>
        </div>-->

        <div class="d-flex justify-center" style="width: 200px">
          <span>
            {{ generateCertificateExpiryDate(registrationData) }}
          </span>
        </div>

        <div class="d-flex justify-center align-center" style="width: 200px">
          <CourseCertificateDownloadDialog
            :trainingRegistration="registrationData"
          >
            <template v-slot:element="{ onClick, loading }">
              <v-btn
                depressed
                icon
                :loading="loading"
                :disabled="registrationData.status !== 'COMPLETED' && !(registrationData.status === 'THIRDPARTY' && registrationData.trainingCertificate && registrationData.trainingCertificate.certificateUrl)"
                @click="onClick"
              >
                <v-icon size="20"> mdi-download </v-icon>
              </v-btn>
            </template>
          </CourseCertificateDownloadDialog>

          <v-btn
            v-if="registrationData.status === 'THIRDPARTY' && havePermissionUpdateTrainingRegistration"
            depressed
            icon
            color="orange"
            :loading="uploadingCertificate"
            @click="triggerFileUpload"
            class="ms-1"
          >
            <v-icon size="20"> mdi-upload </v-icon>
          </v-btn>

          <v-btn
            v-if="registrationData.status === 'THIRDPARTY' && registrationData.trainingCertificate && registrationData.trainingCertificate.certificateUrl"
            depressed
            icon
            color="primary"
            class="ms-1"
            @click="previewCertificate"
          >
            <v-icon size="20"> mdi-eye </v-icon>
          </v-btn>

          <input
            type="file"
            ref="fileInput"
            style="display: none"
            accept=".pdf,image/*"
            @change="onFileSelected"
          />
        </div>
        <div class="d-flex justify-center" style="width: 200px">
          <span>
            {{
              registrationData.invoice && registrationData.invoice.invoiceDate
                ? moment(parseInt(registrationData.invoice.invoiceDate)).format(
                    "DD MMM YYYY"
                  )
                : "-"
            }}
          </span>
        </div>
        <div class="d-flex justify-center" style="width: 200px">
          <InvoiceDownloadButton :trainingRegistration="registrationData">
            <template v-slot:element="{ onClick, loading }">
              <v-btn
                depressed
                icon
                :loading="loading"
                :disabled="!registrationData.invoice"
                @click="onClick"
              >
                <v-icon size="20"> mdi-download </v-icon>
              </v-btn>
            </template>
          </InvoiceDownloadButton>
        </div>

        <div v-if="havePermissionDeleteTrainingRegistration">
          <v-btn
            icon
            depressed
            color="error"
            @click.stop="deleteTrainingRegistration"
          >
            <v-icon> mdi-trash-can-outline </v-icon>
          </v-btn>
        </div>
      </div>
    </v-card>

    <!-- View Uploaded Certificate Dialog -->
    <v-dialog v-model="previewDialog" max-width="800px" scrollable>
      <v-card>
        <v-card-title class="headline d-flex justify-space-between align-center">
          <span>{{ $t("user.profile.certificatePreview") }}</span>
          <v-btn icon @click="previewDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0" style="height: 600px;">
          <template v-if="isPreviewPdf">
            <iframe :src="previewUrl" width="100%" height="100%" frameborder="0"></iframe>
          </template>
          <template v-else>
            <div class="d-flex justify-center align-center" style="height: 100%; width: 100%;">
              <v-img :src="previewUrl" max-height="100%" contain />
            </div>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="downloadPreviewFile">
            <v-icon left>mdi-download</v-icon>
            {{ $t("user.profile.download") }}
          </v-btn>
          <v-btn color="secondary" text @click="previewDialog = false">
            {{ $t("close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Preview / Confirm Upload Dialog -->
    <v-dialog v-model="uploadPreviewDialog" max-width="800px" scrollable persistent>
      <v-card>
        <v-card-title class="headline d-flex justify-space-between align-center">
          <span>{{ $t("user.profile.confirmUpload") }}</span>
          <v-btn icon @click="cancelUpload" :disabled="uploadingCertificate">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0" style="height: 600px;">
          <template v-if="isUploadPreviewPdf">
            <iframe :src="uploadPreviewUrl" width="100%" height="100%" frameborder="0"></iframe>
          </template>
          <template v-else>
            <div class="d-flex justify-center align-center" style="height: 100%; width: 100%;">
              <v-img :src="uploadPreviewUrl" max-height="100%" contain />
            </div>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" :loading="uploadingCertificate" @click="confirmUpload">
            {{ $t("user.profile.confirmUpload") }}
          </v-btn>
          <v-btn color="secondary" text :disabled="uploadingCertificate" @click="cancelUpload">
            {{ $t("user.profile.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { updateTrainingRegistration } from "@/app/course-module/methods/updateTrainingRegistration";
import { createOrUpdateTrainingRegistrationInvoice } from "@/app/course-module/methods/createOrUpdateTrainingRegistrationInvoice";
import { uploadThirdPartyCertificate } from "@/app/course-module/methods/uploadThirdPartyCertificate";
import { hasPermission } from "@/app/user-module/helpers/authHelper.js";

import EditBtn from "../EditBtn.vue";
import CourseCertificateDownloadDialog from "@/app/course-module/components/CourseCertificateDownloadDialog";
import InvoiceDownloadButton from "@/app/invoices-module/components/InvoiceDownloadButton";

export default {
  components: {
    InvoiceDownloadButton,
    CourseCertificateDownloadDialog,
    EditBtn,
  },
  props: {
    registrationData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      registrationStatusArr: ["REGISTERED", "THIRDPARTY", "COMPLETED"],
      invoiceStatusArr: ["PAID", "UNPAID"],

      date1: null,
      date2: null,
      menu1: false,
      menu2: false,
      statusUpdateLoading: false,
      invoiceStatusUpdateLoading: false,
      editBtnLoading1: false,
      editBtnLoading2: false,
      uploadingCertificate: false,

      // Preview & Upload properties
      previewDialog: false,
      previewUrl: "",
      isPreviewPdf: false,
      uploadPreviewDialog: false,
      uploadFileToConfirm: null,
      uploadPreviewUrl: "",
      isUploadPreviewPdf: false,
    };
  },
  computed: {
    havePermissionUpdateTrainingRegistration() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["UPDATE_TRAINING_REGISTRATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionDeleteTrainingRegistration() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["DELETE_TRAINING_REGISTRATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },
  methods: {
    editStartDate() {
      this.date1 = this.$moment(
        parseInt(this.registrationData.startDate)
      ).format("YYYY-MM-DD");
      this.menu1 = true;
    },
    editEndDate() {
      this.date2 = this.$moment(parseInt(this.registrationData.endDate)).format(
        "YYYY-MM-DD"
      );
      this.menu2 = true;
    },
    formatDateServer(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    async updateStartDate() {
      this.menu1 = false;
      this.editBtnLoading1 = true;
      await updateTrainingRegistration({
        id: this.registrationData._id,
        input: {
          startDate: this.formatDateServer(this.date1),
        },
      }).then(result => {
        this.editBtnLoading1 = false;
      });
    },
    async updateEndDate() {
      this.menu2 = false;
      this.editBtnLoading2 = true;
      await updateTrainingRegistration({
        id: this.registrationData._id,
        input: {
          endDate: this.formatDateServer(this.date2),
        },
      }).then(result => {
        this.editBtnLoading2 = false;
      });
    },
    async updateRegistrationStatus(status) {
      this.statusUpdateLoading = true;
      await updateTrainingRegistration({
        id: this.registrationData._id,
        input: { status: status },
      }).then(result => {
        this.$emit("afterStatusUpdate");
        this.statusUpdateLoading = false;
      });
    },
    async updateInvoiceStatus(id, status) {
      this.invoiceStatusUpdateLoading = true;
      await createOrUpdateTrainingRegistrationInvoice(id, status).then(
        result => {
          this.invoiceStatusUpdateLoading = false;
        }
      );
    },
    deleteTrainingRegistration() {
      this.$emit("onDelete", this.registrationData._id);
    },
    formatStatus(status) {
      if (!status) return "-";
      if (status === "THIRDPARTY") return "ThirdParty";
      return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    },
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    onFileSelected(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.uploadFileToConfirm = file;
      this.uploadPreviewUrl = URL.createObjectURL(file);
      this.isUploadPreviewPdf = file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");
      this.uploadPreviewDialog = true;

      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },
    async confirmUpload() {
      if (!this.uploadFileToConfirm) return;
      this.uploadingCertificate = true;
      try {
        const { data, error } = await uploadThirdPartyCertificate({
          trainingRegistrationId: this.registrationData._id,
          file: this.uploadFileToConfirm,
        });

        if (data) {
          this.$emit("afterStatusUpdate");
          this.uploadPreviewDialog = false;
          if (this.uploadPreviewUrl) {
            URL.revokeObjectURL(this.uploadPreviewUrl);
          }
          this.uploadFileToConfirm = null;
          this.uploadPreviewUrl = "";
        } else {
          this.$emit("error", "update");
        }
      } catch (e) {
        console.error(e);
        this.$emit("error", "update");
      } finally {
        this.uploadingCertificate = false;
      }
    },
    cancelUpload() {
      if (this.uploadPreviewUrl) {
        URL.revokeObjectURL(this.uploadPreviewUrl);
      }
      this.uploadPreviewDialog = false;
      this.uploadFileToConfirm = null;
      this.uploadPreviewUrl = "";
    },
    previewCertificate() {
      if (
        this.registrationData.trainingCertificate &&
        this.registrationData.trainingCertificate.certificateUrl
      ) {
        const url = this.getImage(
          this.registrationData.trainingCertificate.certificateUrl
        );
        this.previewUrl = url;
        this.isPreviewPdf = this.registrationData.trainingCertificate.certificateUrl
          .toLowerCase()
          .endsWith(".pdf");
        this.previewDialog = true;
      }
    },
    async downloadPreviewFile() {
      if (
        !this.registrationData.trainingCertificate ||
        !this.registrationData.trainingCertificate.certificateUrl
      )
        return;
      try {
        const response = await fetch(this.previewUrl);
        const blob = await response.blob();
        const parts = this.registrationData.trainingCertificate.certificateUrl.split(
          "."
        );
        let ext = "pdf";
        if (parts.length > 1) {
          const urlExt = parts.pop().toLowerCase();
          if (["pdf", "jpg", "jpeg", "png"].includes(urlExt)) {
            ext = urlExt;
          }
        }
        const title =
          this.registrationData.training && this.registrationData.training.title
            ? this.getLocalisedValue(this.registrationData.training.title)
            : "certificate";
        const employeeName =
          this.registrationData.employee && this.registrationData.employee.user
            ? `${this.registrationData.employee.user.firstName || ""} ${this
                .registrationData.employee.user.lastName || ""}`.trim()
            : "employee";
        const fileName = `${employeeName}-${title}.${ext}`.replace(/\s+/g, "_");
        this.downloadFile({ data: blob, fileName });
      } catch (e) {
        console.error("Error downloading file:", e);
        window.open(this.previewUrl, "_blank");
      }
    },
  },
};
</script>
